import BillingPricingComponent from "./component"

class BillingPricingPlanGroup extends BillingPricingComponent {
  static get selector() {
    return "[data-billing-pricing-plan-group]"
  }

  init() {
    this.selected = this.element.dataset.billingPricingPlanGroupPreselected === "true"

    this.initialized()
  }

  valid() {
    return super.valid() && this.id
  }

  show() {
    this.selected = true

    this.element.classList.replace("hidden", "block")
  }

  hide() {
    this.selected = false

    this.element.classList.replace("block", "hidden")
  }

  get id() {
    if (this._id === undefined) {
      this._id = this.element.dataset.billingPricingPlanGroup
    }
    return this._id
  }
}

export default BillingPricingPlanGroup
